import { render, staticRenderFns } from "./monogram.vue?vue&type=template&id=96daec62&scoped=true&"
var script = {}
import style0 from "./monogram.vue?vue&type=style&index=0&id=96daec62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96daec62",
  null
  
)

export default component.exports